module.exports = __webpack_public_path__ + "static/img/company_history_renwu2019.aa045f71.jpg";